import { Model } from '@nozbe/watermelondb';
import { field, date, writer, relation,text } from '@nozbe/watermelondb/decorators';
import { INAPP_SCHEMA } from '../schema';

export default class InApp extends Model {
    static table = INAPP_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @text('description_json') description_json;
    @text('description') description;
    @field('pending') pending;
    @text('action') action;
    @text('result') result;
    @text('title') title;
    @text('cta') cta;

    @date('shown_at') shown_at;

    @relation('business', 'business_id') business;

    @writer async closeInApp(result) {
        await this.update(inapp => {
            inapp.pending = false
            inapp.result = result
            inapp.shown_at = new Date().getTime()
        })
    }
}